// PWA Manifest dinâmico
const manifestData = {
  "short_name": "Marabu Club",
  "name": "MARABU OPEN CLUB",
  "description": "Clube de piscina tropical - Ingressos, esportes, estética e bem-estar no Rio de Janeiro",
  "lang": "pt-BR",
  "start_url": "/",
  "scope": "/",
  "display": "standalone",
  "orientation": "portrait",
  "theme_color": "#FF5A26",
  "background_color": "#FDFBF7",
  "categories": ["lifestyle", "sports", "entertainment"],
  "icons": [
    { "src": "https://customer-assets.emergentagent.com/job_aqua-membership-1/artifacts/mf9ppe2q_WhatsApp%20Image%202026-04-07%20at%2020.19.17.jpeg", "sizes": "192x192", "type": "image/jpeg", "purpose": "any" },
    { "src": "https://customer-assets.emergentagent.com/job_aqua-membership-1/artifacts/mf9ppe2q_WhatsApp%20Image%202026-04-07%20at%2020.19.17.jpeg", "sizes": "512x512", "type": "image/jpeg", "purpose": "maskable" }
  ]
};

const blob = new Blob([JSON.stringify(manifestData)], {type: 'application/json'});
const manifestURL = URL.createObjectURL(blob);
document.querySelector('link[rel="manifest"]').setAttribute('href', manifestURL);

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// SW update prompt helper
function showUpdateBanner() {
  if (document.getElementById("sw-update-banner")) return;
  const banner = document.createElement("div");
  banner.id = "sw-update-banner";
  banner.style.cssText = "position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:9999;background:#042F2E;color:#fff;padding:14px 24px;border-radius:16px;display:flex;align-items:center;gap:12px;font-family:Manrope,sans-serif;box-shadow:0 10px 40px rgba(0,0,0,0.3);max-width:90vw;";
  banner.innerHTML = '<span style="font-size:14px;font-weight:600;">Nova versão disponível!</span><button id="sw-update-btn" style="background:#FF5A26;color:#fff;border:none;border-radius:99px;padding:8px 20px;font-weight:700;font-size:13px;cursor:pointer;">Atualizar</button>';
  document.body.appendChild(banner);
  document.getElementById("sw-update-btn").addEventListener("click", function() {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  });
}

// Service Worker registration with update prompt
if ("serviceWorker" in navigator) {
  window.addEventListener("load", function() {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      var promises = registrations.map(function(reg) {
        if (!reg.installing && !reg.waiting && !reg.active) return reg.unregister();
        return Promise.resolve();
      });
      return Promise.all(promises);
    }).then(function() {
      return navigator.serviceWorker.register("/sw.js");
    }).then(function(registration) {
      // Check for updates every 5 minutes
      setInterval(function() {
        try { registration.update(); } catch(e) {}
      }, 300000);
      // Detect new SW waiting
      registration.addEventListener("updatefound", function() {
        var newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener("statechange", function() {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              showUpdateBanner();
            }
          });
        }
      });
    }).catch(function() {});
  });
}
